<!--
 * @Description  : 知识库管理 - 文库管理
 * @Author       : zcc
 * @Date         : 2025-04-23 14:36:59
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-10-22 09:23:31
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\library\library-management\index.vue
-->
<template>
	<filter-layout @search="search" @reset="resetSearch" hasMore>
		<template #filter>
			<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="queryObj" label-width="110px">
				<el-form-item label="标题" prop="title">
					<el-input v-model="queryObj.title" placeholder="请输入" class="w100" clearable></el-input>
				</el-form-item>
				<el-form-item label="文号" prop="referNo">
					<el-input v-model="queryObj.referNo" placeholder="请输入" class="w100" clearable></el-input>
				</el-form-item>
				<el-form-item label="颁布机关" prop="issueUnit">
					<el-input v-model="queryObj.issueUnit" placeholder="请输入" class="w100" clearable></el-input>
				</el-form-item>
				<el-form-item label="时效性" prop="efficient">
					<el-select v-model="queryObj.efficient" clearable multiple collapse-tags filterable>
						<el-option :label="item.sname" :value="item.value" v-for="item in projectDict.zsksxx" :key="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</template>
		<template #more>
			<el-form class="flex-row-form colspan-4" size="small" ref="searchRef2" :model="queryObj" label-width="110px">
				<el-form-item label="施行日期" prop="dateArr" class="date-time">
					<el-date-picker
						v-model="queryObj.dateArr"
						type="daterange"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="所属分类" prop="type">
					<el-cascader
						class="w100 sp-cascader"
						clearable
						v-model="queryObj.type"
						multiple
						placeholder="请选择"
						:options="typeDict"
						:props="{
							expandTrigger: 'hover',
							label: 'sname',
							multiple: true,
							value: 'id',
							emitPath: false
						}"
						collapse-tags
						separator=">"
					></el-cascader>
				</el-form-item>
				<el-form-item label="类别" prop="classType">
					<el-select v-model="queryObj.classType" clearable>
						<el-option label="政策法规类" :value="0"></el-option>
						<el-option label="标准图集类" :value="1"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</template>
		<template #content>
			<!-- 非请求参数 正常查看 -->
			<div class="w-table-layout w-table-page pdt10">
				<div class="w-table-content">
					<vxe-grid ref="xGrid" v-bind="gridOptions" height="100%">
						<!-- 模拟工具栏左侧 -->
						<template #toolbar_buttons> </template>
						<!-- 模拟工具栏右侧 -->
						<template #toolbar_tools>
							<!--  -->
							<el-button type="primary" size="small" @click="handleBtn('add', {})">
								新建文档
							</el-button>
							<el-button type="primary" size="small" plain class="ml10" @click="doExport">
								批量下载
							</el-button>
						</template>

						<!-- 操作列   -->
						<template #tool="{ row }">
							<el-button type="success" size="small" round plain class="table-btn" @click="handleBtn('view', row)">
								查看
							</el-button>
							<el-button type="success" size="small" round plain class="table-btn" @click="handleBtn('edit', row)">
								编辑
							</el-button>
						</template>

						<template #status="{ row }">
							<vxe-switch
								v-model="row.status"
								open-label="启用"
								close-label="禁用"
								:open-value="1"
								:close-value="0"
								@change="changeStatus($event, row)"
							></vxe-switch>
						</template>

						<!-- 模板渲染 - 所属分类 -->
						<template #typeSlot="{ row }">
							<span class="link-class" @click="handleDetail(row)">
								查看（共{{ row.type && row.type.length ? row.type.length : 0 }}个分类）
							</span>
						</template>

						<!-- 文档正文 -->
						<template #fileName="{ row }">
							<span class="link-class" @click="fileNameClick(row)">
								{{ row.fileName }}
							</span>
						</template>

						<!-- 创建日期 -->
						<template #createDateSlot="{ row }">
							<span v-if="row.createDate">{{ row.createDate.slice(0, 10) }}</span>
							<span v-else>-</span>
						</template>
					</vxe-grid>
				</div>
				<div class="w-table-footer">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="pageList"
						:page-size="pageSize"
						:total="total"
						layout="total, sizes, prev, pager, next, jumper"
						v-if="showPage || total > 0"
					>
					</el-pagination>
				</div>
			</div>
		</template>

		<!-- 新增、编辑、查看文库弹框 -->
		<addDialog ref="addDialog" @updateSearch="search"></addDialog>

		<!-- 所属分类弹框 -->
		<sort-dialog ref="sortDialog"></sort-dialog>
	</filter-layout>
</template>

<script>
import { mapState } from 'vuex'
import { exportPlus } from 'utils/tools'
import * as managementApi from 'api/modules/library/library-management/index.js'
import XEUtils from 'xe-utils'
// components
import addDialog from './components/add-dialog.vue'
import sortDialog from './components/sort-dialog.vue'

export default {
	components: { addDialog, sortDialog },
	data() {
		return {
			name: 'library-management',
			showMore: false, // 是否显示更多
			// 查询表单
			queryObj: {
				title: '', // 标题
				referNo: '', // 文号
				issueUnit: '', // 颁布机关
				efficient: [], // 时效性
				dateArr: '', //  实行日期
				applyStartDate: '', // 实行日期（起）
				applyEndDate: '', // 实行日期（止）
				type: [], // 所属分类
				classType: ''
			},
			// 列过滤配置
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			showPage: false,
			loading: false,
			// 表格配置
			gridOptions: {
				// 开启溢出隐藏
				showOverflow: true,
				showHeaderOverflow: true,
				autoResize: true,
				border: true,
				data: [], // 表格数据
				scrollY: {
					enabled: true, //滚动模式
					gt: 10 //指定大于行数就滚动
				},
				// 工具栏配置
				toolbarConfig: {
					custom: false,
					slots: {
						tools: 'toolbar_tools',
						buttons: 'toolbar_buttons'
					}
				},
				// 列配置
				columnConfig: {
					resizable: true
				},
				editConfig: {
					trigger: 'click',
					mode: 'cell',
					enabled: false
					// enabled: isEdit
				},
				treeConfig: {
					childrenField: 'children',
					expandAll: true,
					parentField: 'pid',
					indent: 10,
					transform: false,
					rowField: 'id',
					iconOpen: 'vxe-icon-folder-open',
					iconClose: 'vxe-icon-folder'
				},
				columns: [],
				rowConfig: {
					keyField: 'id',
					isHover: true,
					isCurrent: true
				},
				checkboxConfig: { reserve: true }
			},
			typeDict: [] // 所属分类数组
		}
	},
	methods: {
		// 静态数组（全列头）
		getStaticColumns() {
			this.gridOptions.columns = XEUtils.clone(this.staticColumns, true)
			// 静态列头赋值
			this.$nextTick(() => {
				this.$refs.xGrid.refreshColumn()
				this.fetchData()
			})
		},
		// 点击重置按钮
		resetSearch() {
			// 重置表单
			this.queryObj = {
				title: '', // 标题
				referNo: '', // 文号
				issueUnit: '', // 颁布机关
				efficient: [], // 时效性
				dateArr: '', //  实行日期
				applyStartDate: '', // 实行日期（起）
				applyEndDate: '', // 实行日期（止）
				type: [], // 所属分类
				classType: '',	// 分类
			}
			this.search()
		},

		// 查询
		search() {
			this.fetchData()
		},

		// 异步抓取数据
		fetchData() {
			this.loading = true

			let params = { ...JSON.parse(JSON.stringify(this.queryObj)) }
			// 时间段数据处理
			params.applyStartDate = params.dateArr && params.dateArr.length > 0 ? params.dateArr[0] : ''
			params.applyEndDate = params.dateArr && params.dateArr.length > 0 ? params.dateArr[1] : ''
			// 删除时间段
			delete params.dateArr

			params.current = this.currentPage
			params.size = this.pageSize
			this.gridOptions.data = []
			this.total = 0

			managementApi
				.selectDocPage(params)
				.then((res) => {
					if (res.code == 0) {
						// 所属分类数组赋值
						this.typeDict = res.data.docTypeTree
						this.gridOptions.data = res.data.docManagePage.records
						this.total = Number(res.data.docManagePage.total)
						this.showPage = Number(res.data.docManagePage.total) === 0
					}
					this.loading = false
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.fetchData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.fetchData()
		},

		// 操作列按钮事件
		handleBtn(type, row) {
			this.$refs.addDialog.initDialog(row, type, this.typeDict)
			// switch (type) {
			//   // 新增属性
			//   case "add":
			//   // 编辑
			//   case "edit":
			//   // 查看
			//   case "view":
			//   this.$refs.addDialog.initDialog(row, type, this.typeDict);
			//     break;
			// }
		},

		// 点击导出
		doExport() {
			let records = this.$refs.xGrid.getCheckboxRecords() // 当前页勾选
			let records2 = this.$refs.xGrid.getCheckboxReserveRecords() // 其他页勾选
			let arr = [...records, ...records2]
			if (arr.length == 0) {
				this.$message.warning({ message: '请先选择数据!' })
				return
			}
			// id集合
			let ids = []
			arr.map((item) => {
				ids.push(item.id)
			})
			let params = { ids }

			let path = '/docManage/downloadBatch'
			exportPlus(path, params)
		},

		// 状态切换
		changeStatus(e, row) {
			this.$confirm('确认修改该项状态？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					managementApi.updateDocStatus({ id: row.id }).then((res) => {
						if (res.code == 0) {
							this.$message.success({ message: '操作成功' })
							// 状态更改后需要重新获取数据
							this.fetchData()
						}
					})
				})
				.catch(() => {
					if (e.value == 0) row.status = 1
					else row.status = 0
					this.$message.success({ message: '已取消修改!' })
				})
		},

		// 所属分类弹框打开
		handleDetail(row) {
			this.$refs.sortDialog.initDialog(row)
		},

		// fileName点击事件
		fileNameClick(row) {
			this.$previewFn(row.fileUrl, row.fileName)
			// window.open(process.env.VUE_APP_PREVIEW_URL + row.fileUrl, '_blank')
		}
	},
	created() {
		// 获取静态列头
		this.getStaticColumns()
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),

		// 静态列
		staticColumns() {
			return [
				{
					field: 'checkbox',
					type: 'checkbox',
					title: '',
					width: 60,
					minWidth: '',
					align: 'center',
					headerAlign: 'center',
					visible: true,
					forbidCheck: 1,
					forbidDrag: 1
				},
				{
					type: 'seq',
					title: '序号',
					width: 70,
					align: 'center',
					headerAlign: 'center',
					visible: true,
					forbidCheck: 1,
					forbidDrag: 1
				},
				{
					field: 'title',
					title: '标题',
					minWidth: 220,
					align: 'left',
					headerAlign: 'left',
					visible: true,
					forbidCheck: 1,
					forbidDrag: 1
				},
				{
					field: 'type',
					title: '所属分类',
					minWidth: 140,
					visible: true,
					slots: { default: 'typeSlot' }
				},
				{
					field: 'issueUnit',
					title: '颁布机关',
					minWidth: 100,
					visible: true
				},
				{
					field: 'referNo',
					title: '文号',
					minWidth: 100,
					visible: true
				},
				{
					field: 'efficientName',
					title: '时效性',
					minWidth: 100,
					visible: true
				},
				{
					field: 'releaseDate',
					title: '公示日期',
					minWidth: 100,
					visible: true
				},
				{
					field: 'applyDate',
					title: '施行日期',
					minWidth: 100,
					visible: true
				},
				{
					field: 'fileName',
					title: '文档正文',
					minWidth: 140,
					visible: true,
					slots: { default: 'fileName' }
				},
				{
					field: 'createUser',
					title: '创建人',
					minWidth: 80,
					visible: true
				},
				{
					field: 'createDate',
					title: '创建日期',
					minWidth: 100,
					visible: true,
					slots: { default: 'createDateSlot' }
				},
				{
					field: 'status',
					title: '状态',
					width: 100,
					visible: true,
					slots: { default: 'status' }
				},
				{
					title: '操作',
					field: 'tool',
					width: 130,
					visible: true,
					slots: { default: 'tool' }
				}
			]
		}
	},
	watch: {}
}
</script>
<style scoped lang="less">
.w100 {
	width: 100% !important;
}
.title {
	font-size: 16px;
	font-weight: bold;
	color: #000;
	padding: 15px 0;
}
.table-footer {
	display: flex;
	align-items: center;
	justify-self: center;
	margin-top: 10px;
}
.link-class {
	color: #3ba1ff;
	cursor: pointer;
}
/deep/ .vxe-table--render-default.vxe-editable .vxe-body--column {
	height: 40px;
}
</style>
